import React from 'react'
import {
    Button,
    Table,
    Chip,
    Icon
} from '@arnsbogroup/react-voicearchive'
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import SearchPage from 'containers/SearchPage'
import messages from './messages'

const SchedulingPollPage = ({ history, ...props }) => {
    const { formatMessage } = useIntl()

    const getStatusBadge = (status) => {
        const badges = {
            open: { state: 'success', label: formatMessage(messages.open) },
            closed: { state: 'negative', label: formatMessage(messages.closed) }
        }

        const badge = badges[status] || badges.closed

        return (
            <Chip state={badge.state}>
                {badge.label}
            </Chip>
        )
    }

    const copyLinkToClipboard = (poll, e) => {
        e.preventDefault()
        e.stopPropagation()

        const link = poll.publicUrl || `${window.location.origin}/scheduling-poll/${poll.hash_id}`
        navigator.clipboard.writeText(link).then(() => {
            toastr.success(formatMessage(messages.linkCopied))
        }).catch(() => {
            toastr.error(formatMessage(messages.linkCopyFailed))
        })
    }

    return (
        <div className={props.match.isExact ? 'w-full' : 'w-full max-w-md'}>
            {props.match.isExact &&
                <div className="m-2">
                    <Button
                        onClick={() => history.push('/scheduling-polls/create')}
                        icon={['fas', 'plus']}
                    >
                        <FormattedMessage {...messages.newPoll} />
                    </Button>
                </div>
            }

            <SearchPage {...props}
                containerClassName="w-full"
                baseApiUrl="/rest/v2/schedulingpoll"
                components={{
                    Tr: ({ childProps = {}, ...innerProps }) => {
                        return (
                        <Table.Tr
                            {...innerProps }
                            onClick={childProps.uid ? () => history.push(`/scheduling-polls/${childProps.uid}`) : undefined}
                            className={{
                                'cursor-pointer': !!childProps,
                                'bg-blue-50': props?.location?.pathname.startsWith(`/scheduling-polls/${childProps?.uid}`),
                            }}
                        />
                        )
                    },
                    Td: ({ childProps = {}, ...props }) => (
                        <Table.Td
                        {...props }
                        className={{
                            'closed': 'line-through opacity-50',
                        }[childProps.status] ?? undefined}
                        />
                    )
                }}
                head={{
                    title: { label: formatMessage(messages.title) },
                    status: { label: formatMessage(messages.status) },
                    order_uid: { label: formatMessage(messages.orderId) },
                    timeSlots: { label: formatMessage(messages.timeSlots) },
                    responses: { label: formatMessage(messages.responses) },
                    created: { label: formatMessage(messages.created) },
                    actions: { label: <Icon icon={['fas', 'ellipsis-v']} />, className: 'w-32' }
                }}
                body={{
                    title: (request) => (
                        <div
                            className="cursor-pointer"
                            onClick={() => history.push(`/scheduling-polls/${request.uid}`)}
                        >
                            <div className="text-sm font-medium">
                                {request.title}
                            </div>
                            {request.description && (
                                <div className="text-sm text-gray-500 truncate max-w-xs">
                                    {request.description}
                                </div>
                            )}
                        </div>
                    ),
                    status: (request) => getStatusBadge(request.status),
                    order_uid: (request) => (
                        <span className="text-sm">
                            {request.order_uid || formatMessage(messages.none)}
                        </span>
                    ),
                    timeSlots: (request) => (
                        <span className="text-sm">
                            <FormattedMessage {...messages.options} values={{ count: request.timeSlotCount || 0 }} />
                        </span>
                    ),
                    responses: (request) => (
                        <span className="text-sm">
                            <span className="font-semibold text-primary">
                            </span> <FormattedMessage {...messages.responsesCount} values={{ count: request.responseCount || 0 }} />
                        </span>
                    ),
                    created: (request) => (
                        <span className="text-sm">
                            <FormattedDate value={new Date(request.crdate * 1000)} />
                        </span>
                    ),
                    actions: (request) => (
                        <div className="flex gap-2">
                            <button
                                onClick={(e) => copyLinkToClipboard(request, e)}
                                className="text-primary hover:text-primary-darker"
                                title={formatMessage(messages.copyParticipantLink)}
                            >
                                <Icon icon={['fas', 'copy']} />
                            </button>
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default SchedulingPollPage
